export const SET_CURRENT_SITE = 'SET_CURRENT_SITE'
export const CLEAR_CURRENT_SITE = 'CLEAR_CURRENT_SITE'
export const GET_CURRENT_SITE = 'GET_CURRENT_SITE'



// WEBPACK FOOTER //
// ./src/common/store/Site/types.js